import {post} from '../utils/http';
import {flagOfPoiUid, isOldTrip} from '../helpers/favorite';
import toast from '../components/Toast';
import {supportNative} from '../native/util';
import Detector from '../utils/detector';

const isZuzuche = Detector.browser.zuzuche;
const isTantuMap = Detector.browser.tantumap;

/**
 * 对收藏夹的点进行数据修正
 */
export function fixPoiInfo(trip_id, poi_uid_map) {
  let url = '/m/v2/?m=api/poi/fix_poi_info';

  return post(url, {
    data: {
      trip_id,
      append_city: true,
      poi_uid_map,
    }
  });
}

/**
 * 修正收藏夹数据，错误时返回原trip，只需监听then，无catch状态
 * @param trip
 * @return trip
 */
export function fixPoiInfo_trip(trip) {
  // 抽取需要修正的数据
  let needFix = false,
    needFixPois = {};

  for (let i in trip.poi_uid_map) {
    if (trip.poi_uid_map[i].favorites_id) {
      needFix = true;
      needFixPois[i] = trip.poi_uid_map[i];
    }
  }

  if (needFix) {
    return fixPoiInfo(trip.trip_id, needFixPois)
      .then(res => {
        let { fix_map, city_info_map } = res;

        // 遍历更换掉trip里的poi
        for (let i in fix_map) {
          if (fix_map[i].msg != 'success') continue;

          let newPoi = fix_map[i].info;

          trip.poi_list.forEach(day => {
            day.pois.forEach((poi, index) => {
              if (poi.poi_uid == i) {
                day.pois[index] = {
                  poi_uid: newPoi.poi_uid,
                  flag: flagOfPoiUid(newPoi.poi_uid)
                };
              }
            });
          });

          delete trip.poi_uid_map[i];
          trip.poi_uid_map[newPoi.poi_uid] = newPoi;
        }

        // 填充城市
        trip.city_info_maps = {...trip.city_info_maps, ...city_info_map};

        return trip;
      })
      .catch(err => {
        console.warn(err);
        toast(err.message);
        return trip;
      });
  } else {
    return Promise.resolve(trip);
  }
}


function isOnLine() {
  // fuck android
  if (window.zzcApp) {
    return window.zzcApp.networkIsConnection;
  } else {
    return window.navigator.onLine;
  }
};


/**
 * 只用于通过poi点查看或者收藏夹直接添加poi点到行程
 * 同时保存到APP和后端
 */
export function saveTrip(trip_id, trip, is_published, isStrict) {
  // demo行程不需要保存
  // 虽然觉得应该在业务层处理，但是这里处理简单很多
  if (trip.is_demo) {
    return Promise.all([true, true]);
  }

  // 第一次编辑“旧行程”
  if (trip && isOldTrip(trip) && !trip.operate_times) {
    trip.operate_times = 1;
  }

  // APP接口和PHP接口的调用
  let promiseApp, promisePhp;

  if (isTantuMap || isZuzuche) {
    promiseApp = saveTrip.app(trip_id, trip, is_published);
  } else {
    promiseApp = Promise.resolve(true);
  }

  if (isOnLine() || isStrict) {
    promisePhp = saveTrip.php(trip_id, trip, is_published);
  } else {
    promisePhp = Promise.resolve(true);
  }

  return Promise.all([promiseApp, promisePhp]);
}

saveTrip.app = function (trip_id, trip, is_published) {
  if (is_published) {
    trip.is_show = true;
  }

  return new Promise(function (resolve, reject) {
    if (!supportNative()) {
      console.warn('不支持JSSDK');
      return resolve(true);
    }

    if (isTantuMap && trip.is_show) {
      zzc.call('trip_setTripData', {
        tripId: trip_id,
        data: JSON.stringify(trip),
        complete: function (res) {
          if (res.state) {
            reject(new Error(res.message));
          } else {
            resolve(res);
          }
        }
      });
    } else {
      zzc.call('base_localStorageSetItem', {
        key: trip_id,
        namespace: 'trip',
        value: JSON.stringify(trip),
        complete: function (res) {
          if (res.state) {
            reject(new Error(res.message));
          } else {
            resolve(res);
          }
        }
      });
    }

  });
};

saveTrip.php = function (trip_id, trip, is_published) {
  let url = '/m/v2/?m=api/trip/sync/put';

  // 排除掉数据量大的字段
  trip = {
    ...trip,
    poi_uid_map: undefined,
    city_info_maps: undefined,
  };

  return post(url, {
    data: {
      trip_id,
      is_published: is_published ? 1 : undefined,
      trip
    }
  });
};



// WEBPACK FOOTER //
// ./src/services/favorite.js